import React from 'react'

import { Element } from '@Components/Elements/Types'
import { RTEContent } from '@Components/RTEContent'

export const ElementTypographyRTE = ({ appearance, rte }: Extract<Element, { __typename: 'ElementTypographyRTE' }>) => (
  <RTEContent
    data={rte}
    style={{
      backgroundColor: appearance?.backgroundColor || undefined,
      color: appearance?.textColor || undefined,
      fontFamily: `var(--font-${appearance?.font || 'gotham'})`,
    }}
  />
)
